import React from "react";

export default class EmailForm extends React.Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      status: "",
      name:"",
      email: "",
      message: "",
      consent: false
    };
  }

  // onChangeInput(e){
  //   this.setState({

  //   })
  // }

  render() {
    const { status } = this.state;
    return (
      <form
        onSubmit={this.submitForm}
        action="https://formspree.io/f/xnqokyar"
        method="POST"
      >
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          className="form-control"
                          placeholder={this.props.data ? this.props.data.name : "loading"}
                          required="required"
                          // value={this.state.name}
                          onChange={(e) => {this.setState({name:e.target.value})}}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          className="form-control"
                          placeholder={this.props.data ? this.props.data.email : "loading"}
                          required="required"
                          // value={this.state.mail}
                          onChange={(e) => {this.setState({email:e.target.value})}}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder={this.props.data ? this.props.data.message : "loading"}
                      required
                      // value={this.state.message}
                      onChange={(e) => {this.setState({message:e.target.value})}}
                    ></textarea>
                    <p className="help-block text-danger"></p>
                  </div>
                  <div >
                    <div style={{float: 'left', marginRight: '1em'}}>
                      <input 
                        type="checkbox" 
                        id="consent" name="consent" 
                        // checked={{this.state.consent}}
                        onChange={ (e) => { 
                          // console.log("Changed consent to:", e.target.checked)
                          this.setState({consent: e.target.checked})
                        }}
                      />
                    </div>
                    <p> 
                      {this.props.data? this.props.data.consent: "loading"}
                      <a href="./cookies/CENTRO_MEDICO_LLUCMAJOR_SL_Politica_de_PRIVACIDAD_2022.html">
                        {this.props.data? this.props.data.consentPrivacy: "loading"}
                      </a>, 
                      <a href="./cookies/CENTRO_MEDICO_LLUCMAJOR_SL_Consentimiento_para_el_tratamiento_de_datos.html">
                        {this.props.data? this.props.data.consentData: "loading"}
                      </a>
                    </p>
                  </div>
                  <div id="success">
                  {status === "SUCCESS" ? 
                    <p>{this.props.data.success} </p> 
                    : <button type="submit" disabled={!this.state.consent} className="btn btn-custom btn-lg">
                        {this.props.data.sendButton}
                      </button>}
                  {status === "ERROR" && <p>{this.props.data.error}</p>}
                  </div>
      </form>
    );
  }

  submitForm(ev) {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        this.setState({ status: "SUCCESS" });
      } else {
        this.setState({ status: "ERROR" });
      }
    };
    xhr.send(data);
  }
}